import type { PermissionApi } from '@data-delivery/permission-ui-api';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { permissionQueryClient } from '../../query-client';
import { sftpUsersKeys } from './sftp-users-keys';

export function useBusinessGroupUsersRQ(explicitBusinessGroupId?: string) {
  const params = useParams();
  const businessGroupId = explicitBusinessGroupId || params.id || params.businessGroupId || '';

  const bgUsersQuery = useQuery(
    businessGroupId
      ? sftpUsersKeys.byBusinessGroupQuery(businessGroupId)
      : {
          queryKey: ['sftp-users', 'by-bg', 'none'],
          enabled: false,
          queryFn: async () => [] as PermissionApi.UserEntity[],
        },
  );
  const filtered: PermissionApi.UserEntity[] = bgUsersQuery.data || [];

  return {
    businessGroupId,
    users: filtered,
    isLoading: bgUsersQuery.isLoading,
    isError: bgUsersQuery.isError,
    error: bgUsersQuery.error,
    refetch() {
      if (businessGroupId) {
        permissionQueryClient.invalidateQueries({
          queryKey: sftpUsersKeys.byBusinessGroup(businessGroupId),
        });
      }
    },
    getById: (id: string) => filtered.find(u => u.id === id),
  } as const;
}
